import * as THREE from 'three';
import {matrixFromSimd} from "./matricesFormaters";
import Font from '../../assets/fonts/roboto';

let fontLoader = new THREE.FontLoader();
let font = fontLoader.parse(Font);

const addArrow = (arrowBase, transform, index, cameraMatrix) => {
  let arrowMatrix = matrixFromSimd(transform);
  let arrow = arrowBase.clone();

  let text = index.toString();
  let sizes = {
    '1': {
      size: 0.025,
      position: {
        x: -0.01,
        y: 0.065
      }
    },
    '2': {
      size: 0.015,
      position: {
        x: -0.012,
        y: 0.075
      }
    }
  };

  let arrowBBox = new THREE.Box3().setFromObject(arrow).clone();

  let textSize = (arrowBBox.max.y - arrowBBox.min.y) * 0.15;
  let paddingTop = (arrowBBox.max.y - arrowBBox.min.y) * 0.2;
  let yPosition = (arrowBBox.max.y - arrowBBox.min.y)  - paddingTop;

  let textGeo = new THREE.TextGeometry( text, {
    font: font,
    size: textSize, //sizes[text.length].size,
    height: 0.001,
    curveSegments: 10,
    bevelEnabled: false
  });
  let materials = [
    new THREE.MeshPhongMaterial( { color: 0xffffff, flatShading: true } ), // front
    new THREE.MeshPhongMaterial( { color: 0xffffff } ) // side
  ];

  textGeo = new THREE.BufferGeometry().fromGeometry( textGeo );
  let textMesh = new THREE.Mesh( textGeo, materials );
  arrow.add(textMesh);

  let textBBox = new THREE.Box3().setFromObject(textMesh);

  let textWidth = textBBox.max.x - textBBox.min.x;

  let xPosition = arrowBBox.min.x + (((arrowBBox.max.x - arrowBBox.min.x) - textWidth )/2) - 0.001;

  textMesh.position.y = yPosition; //sizes[text.length].position.x;
  textMesh.position.x = xPosition;
  textMesh.position.z = 0;

  arrow.position.setFromMatrixPosition(arrowMatrix);
  arrow.setRotationFromMatrix(matrixFromSimd(cameraMatrix));

  return arrow
};

export {
  addArrow
}
